<template>
  <el-container style="display: block">
    <headers></headers>
    <el-container
      style="
        min-height: 1000px;

        width: 1300px;
        margin: auto;
      "
    >
      <el-aside width="205px" style="background: #fff">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          text-color="#B0B0B2"
          active-text-color="#409EFF"
          :unique-opened="true"
          router
          ref="elMenu"
        >
          <!-- 递归动态菜单 -->
          <myitem></myitem>
        </el-menu>
      </el-aside>

      <div class="orderDetail-div">
        <el-page-header
          class="b-b1"
          style="padding: 20px"
          @back="goBack"
          content="订单详情"
        >
        </el-page-header>

        <div class="main-div">
          <div class="img-box">
            <div class="demo-image">
              <div class="block" style="border: 1px solid rgb(235, 235, 235)">
                <img
                  style="width: 300px; height: 300px"
                  :src="orderInfo.pic"
                  fit="fill"
                />
              </div>
            </div>
            <el-button type="primary" @click="btnFrom(1)" class="ok-btn" v-show="orderInfo.genre >2 && orderInfo.state==2 ">
              确认方案
            </el-button>
            <el-button type="primary" @click="btnFrom(2)" class="ok-btn" v-show="orderInfo.genre >2 && !orderInfo.certificateNumber && orderInfo.state_logo ==4">
              生成授权证书
            </el-button>
             <el-button type="primary" @click="jumplogo(orderInfo.goodsId,orderInfo.mandate,orderInfo.slogan,orderInfo.brandName)" class="ok-btn" v-show="orderInfo.genre ==5 && orderInfo.state_logo ==4">
              升级套餐
            </el-button>
            <el-alert title="生成需要等待1-15分钟，稍后刷新页面查看即可,超时未生成请联系客服" type="warning" show-icon>
            </el-alert>
            <div class="bottom">
              <el-button
                type="primary"
                @click="logoDown"
                class="ok-btn"
                v-show="orderInfo.state_logo=='4'"
                ><i class="el-icon-download"></i>下载文件 </el-button>
            </div>
          </div>

          <div class="info-box">
            <div class="bzt">
              <el-steps :active="orderInfo.state">
                <el-step title="待支付"></el-step>
                <el-step title="待处理"></el-step>
                <el-step title="处理中"></el-step>
                <el-step title="已完成"></el-step>
              </el-steps>
            </div>
            <el-divider content-position="left">订单信息</el-divider>
            <el-descriptions :column="3" class="order-box ">
              <el-descriptions-item label="订单号">{{
                orderInfo.oid
              }}</el-descriptions-item>
              <el-descriptions-item label="下单时间">{{
                orderInfo.create_time
              }}</el-descriptions-item>
              <el-descriptions-item label="LOGO名称">
                {{ orderInfo.brandName }}
              </el-descriptions-item>
              <el-descriptions-item label="LOGO口号">{{
                orderInfo.slogan
              }}</el-descriptions-item>
              <el-descriptions-item label="logo状态">
                {{logostates[orderInfo.state_logo]}}
              </el-descriptions-item>
            </el-descriptions>

          </div>
        </div>

      </div>
    </el-container>
  </el-container>
</template>

<script>
import myitem from "../components/myitem"; // 引入递归菜单组件
import headers from "../components/header"; // 引入递归菜单组件
import { getApi, postApi, postApiJson } from "../../utils/request";

export default {
  data() {
    return {
      activeIndex: this.$route.path,
      orderInfo: [],
      formTabel: {
        state: "",
        time: "",
        oid: "",
        title: "",
        city: "",
        sokey: "",
        mandate: "",
        certificateName: "",
      },
      orderstates: {
					"-1": "删除",
					1: "待付款",
					2: "待确认",
					3: "处理中",
					6: "已完成",
				 5: "已取消",
      },
      mandates: {
        1: "可申请商标",
        2: "可买断",
        3: "可商用",
        4: "精选可买断",
        5: "可商用仅卖一次",
      },
      logostates: {
					1: "待付款",
					2: "待处理",
					3: "生成中",
					4: "已完成",
					5:"已关闭"
				},
      legalInfo: {
        certificateNumber: "",
        certificateName: "",
        legalPersonName: "",
        certificateType: "2",
      },
      btn_name: "确认方案",
      down: false,
      active: 0,
      ruleForm: {
        pass: "",
        checkPass: "",
        age: "",
      },
      dialogVisible: false,
      activeName: "first",
      okbtn: false,
    };
  },
  created: function () {
    this.getOrderDetail();
  },
  methods: {
    handleClose(done) {
      done();
    },
    goBack() {
      this.$router.push({
        name: "order",
      });
    },
    handleClick(tab, event) {
      switch (tab.name) {
        case "second":
          this.legalInfo.certificateType="1"
          break;
        case "first":
          this.legalInfo.certificateType="2"
          break;
      }
      console.log(this.legalInfo.certificateType);
    },
    // 获取订单列表
    getOrderDetail() {
      postApiJson("/logoapi/get_order_details", {
        genre: "1",
        oid: this.$route.query.oid,
      }).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          if (JSON.stringify(res.data.data[0]) == "{}") {
            this.orderInfo = [];
          } else {
            this.orderInfo = res.data.data[0];
            this.orderInfo.pic = this.orderInfo.pic.replace(
              "https://logo.aliyun.com/logo/image",
              "https://s.zaoge.com/logo/get_alilogo.php"
            );
          }
        }
      });
    },
    logoAffirm() {
      postApiJson("/logoapi/logo_confirm_zaoge", {
        oid: this.orderInfo.oid,
        zaoge_oid: this.orderInfo.zaoge_oid
      }).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.btn_name = "生成授权证书";
          location.reload();
        } else {
          this.$message.error(res.data.msg);

        }
      });
    },
    logoCreateLegal() {
      var _this=this
      this.$confirm('一旦提交，无法修改,请仔细检查您填写的信息是否正确', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.logoCreateLegal2()
        }).catch(() => {
          return
        });
    },
    logoCreateLegal2() {
      this.legalInfo.oid = this.orderInfo.oid;
       this.legalInfo.zaoge_oid = this.orderInfo.zaoge_oid;
       this.legalInfo.BizId =this.orderInfo.bizId
      let data = JSON.stringify(this.legalInfo);
      postApiJson("/logoapi/logo_create_legal", this.legalInfo).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          location.reload();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    logoDown() {
      postApiJson("/logoapi/logo_down", { 
        oid: this.orderInfo.oid,
        zaoge_oid: this.orderInfo.zaoge_oid, 
        genre: this.orderInfo.genre
       }).then(
        (res) => {
          console.log(res.data.success);
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            var url=''

                url=res.data.url


        this.$confirm(url, '下载地址', {
          confirmButtonText: '跳转',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
            setTimeout(function () {
              window.open(url);
            }, 100);
        }).catch(() => {
          return
        });

          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    btnFrom(type) {
      if (type == 2) {
        this.dialogVisible = true;
        return;
      } else {
        this.logoAffirm();
      }
    },
    jumplogo(goodsId,mandate,slogan,brandName){
          console.log(goodsId);
          window.open("/logo/logoDetail.html?GoodsId="+GoodsId+"&TagId="+mandate+"&slogan="+mandate+"&BrandName="+mandate)
    }
  },

  components: { myitem, headers },
};
</script>


<style scoped>
.orderDetail-div {
  position: relative;
  text-align: center;
  width: 100%;
  margin-left: 10px;
  background: #fff;
  padding: 0 20px;
}
.main-div {

  margin-top: 20px;
}
.info-box {
  margin-left: 10px;
}

.ok-btn {
  margin: 20px 0 5px 0;
  width: 106px;
  background-color: rgb(4, 105, 255);
  font-size: 13px;
  color: rgb(255, 255, 255);
  cursor: pointer;
}

.bottom {
  position: relative;
  bottom: 0;
  top: 5px;
}
.el-descriptions-item__container {
  font-size: 12px;
  color: rgb(34, 34, 34);
}
.el-page-header__content {
    font-size: 14px;
}
.el-descriptions {
    padding: 20px;
}
.b-b1 {
  border-bottom: 1px solid rgb(235, 235, 235);
}
.b-1 {
  border: 1px solid rgb(235, 235, 235);
}
.el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  line-height: 3.5;
}
.el-page-header__content {
  font-size: 14px;
  color: #303133;
}
.el-step:last-of-type .el-step__line {
  display: block;
}
.bzt {
  text-align: left;
  padding: 0 0 10px 0;
}
.el-drawer__body {
    padding: 0 21px;
}
</style>



// WEBPACK FOOTER //
// src/views/order_detail.vue